// src/services/eventsService.js
// e-Venn-t client. Authed routes go through the shared apiClient (bearer +
// session-recovery on 401); public routes (getPublicEvent, registerForEvent)
// pass auth:false and send no Authorization header.
import { apiFetch } from './apiClient';

const request = (path, opts = {}) => apiFetch(path, opts);

export const eventsService = {
  // --- Organiser endpoints ---
  async listEvents() {
    const data = await request('/v1/events');
    return data?.events ?? [];
  },

  async getEvent(id) {
    const data = await request(`/v1/events/${id}`);
    return data?.event ?? null;
  },

  async createEvent(payload) {
    const data = await request('/v1/events', { method: 'POST', body: payload });
    return data?.event ?? null;
  },

  async updateEvent(id, payload) {
    const data = await request(`/v1/events/${id}`, { method: 'PATCH', body: payload });
    return data?.event ?? null;
  },

  async cancelEvent(id) {
    const data = await request(`/v1/events/${id}`, { method: 'DELETE' });
    return data?.event ?? null;
  },

  async publishEvent(id) {
    const data = await request(`/v1/events/${id}/publish`, { method: 'POST' });
    return data?.event ?? null;
  },

  async getAttendees(id) {
    const data = await request(`/v1/events/${id}/attendees`);
    return data?.attendees ?? [];
  },

  async downloadAttendeesCsv(id) {
    const res = await apiFetch(`/v1/events/${id}/attendees.csv`, { raw: true });
    return res.blob();
  },

  // --- Public endpoints (no auth header) ---
  async getPublicEvent(shortCode) {
    const data = await request(`/v1/events/public/${shortCode}`, { auth: false });
    return data?.event ?? null;
  },

  /**
   * Register an attendee.
   *  - Free events resolve with `{ kind: 'attendee', attendee }`.
   *  - Paid events resolve with `{ kind: 'checkout', checkout: { url, session_id } }`.
   * The caller is responsible for redirecting on the checkout case.
   */
  async registerForEvent(id, { name, email }) {
    const data = await request(`/v1/events/${id}/register`, {
      method: 'POST',
      body: { name, email },
      auth: false,
    });
    if (data?.checkout?.url) return { kind: 'checkout', checkout: data.checkout };
    return { kind: 'attendee', attendee: data?.attendee ?? null };
  },
};
